var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7149 22.7143L18.4862 18.4858M11.3575 21.4284C16.9198 21.4284 21.4288 16.9193 21.4288 11.3571C21.4288 5.79481 16.9198 1.28571 11.3575 1.28571C5.79524 1.28571 1.28613 5.79481 1.28613 11.3571C1.28613 16.9193 5.79524 21.4284 11.3575 21.4284Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), "/>\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_1404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNzFfMTQwNCkiPgogICAgICAgIDxwYXRoIGQ9Ik0yMi43MTQ5IDIyLjcxNDNMMTguNDg2MiAxOC40ODU4TTExLjM1NzUgMjEuNDI4NEMxNi45MTk4IDIxLjQyODQgMjEuNDI4OCAxNi45MTkzIDIxLjQyODggMTEuMzU3MUMyMS40Mjg4IDUuNzk0ODEgMTYuOTE5OCAxLjI4NTcxIDExLjM1NzUgMS4yODU3MUM1Ljc5NTI0IDEuMjg1NzEgMS4yODYxMyA1Ljc5NDgxIDEuMjg2MTMgMTEuMzU3MUMxLjI4NjEzIDE2LjkxOTMgNS43OTUyNCAyMS40Mjg0IDExLjM1NzUgMjEuNDI4NFoiCiAgICAgICAgICAgICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS43MTQyOSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPi8+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzI3MV8xNDA0Ij4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+Cjwvc3ZnPgo=";